import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Award, GraduationCap, HeartPulse } from "lucide-react";
import { api } from "../lib/api";
import { fmtDate } from "../lib/roles";
import { StatusTag } from "./CertManager";

const due = (s) => ["scaduto", "scaduta", "in_scadenza"].includes(s);

export function DeadlinesWidget() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    Promise.all([api("/admin/courses"), api("/admin/certifications"), api("/admin/medical-visits")].map((p) => p.catch(() => ({})))).then(([c, k, v]) => {
      const r = [
        ...(c.effettuati || []).filter((x) => due(x.scadenza_status)).map((x) => ({ id: `c${x.id}`, icon: GraduationCap, kind: "Corso", title: x.nome, who: x.user_nome, date: fmtDate(x.scadenza), status: x.scadenza_status, sort: x.scadenza || "", to: "/admin/courses" })),
        ...(k.items || []).filter((x) => due(x.status)).map((x) => ({ id: `k${x.id}`, icon: Award, kind: "Certificazione", title: x.tipo, who: `${x.cognome} ${x.nome}`, date: fmtDate(x.scadenza), status: x.status, sort: (x.scadenza || "").split("/").reverse().join("-"), to: "/admin/certifications" })),
        ...(v.visits || []).filter((x) => due(x.status)).map((x) => ({ id: `v${x.user_id}`, icon: HeartPulse, kind: "Visita medica", title: "Visita medica", who: `${x.cognome} ${x.nome}`, date: fmtDate(x.scadenza), status: x.status, sort: x.scadenza || "", to: "/admin/medical-visits" })),
      ].sort((a, b) => a.sort.localeCompare(b.sort));
      setRows(r);
    });
  }, []);
  if (!rows) return null;
  return (
    <section className="mb-10" data-testid="deadlines-widget">
      <div className="flex items-center justify-between mb-4"><h2 className="font-display text-xl font-bold text-[var(--navy)]">Scadenze del personale</h2><span className="text-sm text-slate-500">{rows.length} da gestire</span></div>
      {rows.length === 0 ? <div className="panel"><p className="text-slate-500">Nessun corso, certificazione o visita medica in scadenza.</p></div> : (
        <div className="panel !p-0 overflow-hidden">{rows.slice(0, 8).map(({ id, icon: Icon, kind, title, who, date, status, to }) => (
          <Link key={id} to={to} className="flex items-center gap-4 px-5 py-3 border-b last:border-0 hover:bg-slate-50" data-testid={`deadline-${id}`}>
            <Icon className="w-5 h-5 text-[var(--teal)] shrink-0" />
            <div className="min-w-0 flex-1"><p className="font-semibold text-[var(--navy)] text-sm truncate">{who} · {title}</p><p className="text-xs text-slate-500">{kind} · scade {date}</p></div>
            <StatusTag s={status} />
          </Link>))}
          {rows.length > 8 && <p className="text-xs text-slate-500 px-5 py-2">+ altre {rows.length - 8} scadenze</p>}
        </div>)}
    </section>
  );
}
